export function truncateText(node, limit, faded_length) {
    let text = '';
    for (let child of node.childNodes) {
        if (child.nodeType === Node.TEXT_NODE) {
            text += child.textContent;
            if (text.trim().length > limit - faded_length) {
                const visibleText = child.textContent.slice(0, limit - text.trim().length - faded_length);
                let fadedText = child.textContent.slice(limit - text.trim().length - faded_length);

                // Cut off the faded text after fadeLimit characters
                if (fadedText.length > faded_length) {
                    fadedText = fadedText.slice(0, faded_length);
                }

                // Remove the original text node
                node.removeChild(child);

                // Create a new span for the visible text
                const preFadeSpan = document.createElement('span');
                preFadeSpan.textContent = visibleText;
                preFadeSpan.className = 'pre-fade';
                node.appendChild(preFadeSpan);

                // Create a new span for the faded text
                const fadeSpan = document.createElement('span');
                fadeSpan.textContent = fadedText;
                fadeSpan.className = 'fade';
                node.appendChild(fadeSpan);

                return true;
            }
        } else if (child.nodeType === Node.ELEMENT_NODE) {
            if (truncateText(child, limit - text.length, faded_length)) {
                let nextChild = child.nextSibling;
                while (nextChild) {
                    let next = nextChild.nextSibling;
                    node.removeChild(nextChild);
                    nextChild = next;
                }

                return true;
            }

            limit -= child.textContent.trim().length;
        }
    }
    return false;
}

export function fade() {
    // Select all matching elements
    var textElements = document.querySelectorAll('.fade-me');

    textElements.forEach(textElement => {
        var text_length = textElement.textContent.trim().length;
        var shown_length = Math.min(220, text_length);
        var faded_length = Math.min(20, Math.floor(shown_length / 2));

        truncateText(textElement, shown_length, faded_length);
    });
}

fade();
